<template>
  <LayoutMinimal>
    <div
      id="login_or_register"
    >
      <PaymentStatus v-if="paymentResult" :payment="paymentResult"/>
      <template v-if="$auth.ready()">
        <section class="main">
          <div class="login-or-register-box">
            <div class="form">
              <h1 class="title">
                {{$t('login.title')}}
              </h1>
              <h4 class="payment_redirect_msg" v-if="paymentToRedirectTo">
                {{$t('login.payment_redirect_msg')}}
              </h4>
              <div class="login-switch-container">
                <LoginSwitch
                  ref="loginSwitch"
                  :label0="$t('login.switch.label0')"
                  :label1="$t('login.switch.label1')"
                  @true="persistIsModelLogin(true)"
                  @false="persistIsModelLogin(false)"
                  :start="isModelLogin"
                />
              </div>
              
              <LoginForm
                @successfullLogin="successfullAuthHandler"
              />
              <div v-if="isGoogleLoginAvailable" class="social-login">
                <LoginWithGoogleButton/>
              </div>
              <div v-if="isTwitterLoginAvailable" class="social-login">
                <LoginWithTwitterButton/>
              </div>
              <!-- Por el momento solo login, si no tiene cuenta lo mandamos a comprar, de acuerdo a lo solicitado por Alvaro -->
              <!--<RegisterForm
                    @successfullRegister="successfullAuthHandler"
              />-->
              <router-link
                class="no-account"
                :to="{name: 'signup'}"
              >
                <h2 class="singup active">
                  {{$t('login.singup')}}
                </h2>
              </router-link>
              <router-link
                  class="support-link"
                  :to="{name: 'support'}">
                  {{ $t('zammad_support.link') }}
              </router-link>
            </div>
            <div class="change-mode">
              <div class="content">
                <div v-if="modeLogin">
                  <h1 class="title">
                    {{$t('login.requires_registration.title')}}
                  </h1>
                  <h4 class="subtitle">
                    {{$t('login.requires_registration.subtitle')}}
                  </h4>
                  <router-link
                    :to="{name: 'purchase.subscription'}"
                  >
                    <h2 class="get-access-here active">
                      {{$t('footer.get_access')}}
                    </h2>
                  </router-link>
                  <router-link
                    :to="{name: 'webstars.index'}"
                  >
                    <div class="footer">
                      {{$t('login.requires_registration.footer')}}
                    </div>
                  </router-link>
                </div>
                <div v-else>
                  <h1 class="title">
                    {{$t('register.requires_login.title')}}
                  </h1>
                  <h4 class="subtitle">
                    {{$t('register.requires_login.subtitle')}}
                  </h4>
                  <router-link
                    :to="{name: 'purchase.subscription'}"
                  >
                    <h2 class="get-access-here active">
                      {{$t('footer.get_access')}}
                    </h2>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
    </div>
    <template slot="after">
      <!--      <Footer/>-->
    </template>
  </LayoutMinimal>
</template>

<script>
    import LoginForm from '../components/LoginForm';
    import RegisterForm from '../components/RegisterForm';
    import Footer from '../components/Footer';
    import LayoutMinimal from '../layouts/LayoutMinimal';
    import PaymentStatus from "../components/PaymentStatus";
    import LoginSwitch from "../components/Login/Switch";
    import resources from '../resources';
import LoginWithGoogleButton from '../components/Login/LoginWithGoogleButton.vue';
import Cache from '../modules/Cache';
import LoginWithTwitterButton from '../components/Login/LoginWithTwitterButton.vue';
import { Handler as WebstarAuthHandler } from '../modules/WebstarAuth/Handler'

    const REDIRECT_CASES = {
      webstars: 'webstars-panel'
    };

    export default {
      components: {
    LoginForm,
    RegisterForm,
    Footer,
    LayoutMinimal,
    PaymentStatus,
    LoginSwitch,
    LoginWithGoogleButton,
    LoginWithTwitterButton
},
      data(){
        const isModelLogin = this.$route.query.redirect === REDIRECT_CASES.webstars;
        this.persistIsModelLogin(isModelLogin);

        return {
          user: null,
          modeLogin: true, //!parseInt(this.$route.query.r),
          prevRoute: null,
          isModelLogin,
          //cuando se setea la variable env GOOGLE_LOGIN_AVAILABLE con true, aparece el botón
          googleLoginAvailable: process.env.VUE_APP_GOOGLE_LOGIN_AVAILABLE,
          //cuando se setea la variable env TWITTER_LOGIN_AVAILABLE con true, aparece el botón
          twitterLoginAvailable: process.env.VUE_APP_TWITTER_LOGIN_AVAILABLE,
        }
      },
      methods: {
        successfullAuthHandler(response) {
          if (this.paymentToRedirectTo) {
            this.$router.push({name: 'payment.result', query: {id: this.paymentToRedirectTo}});
            return;
          }

          const redirect = this.redirectUrl(response.data);
          if (redirect) return;

          if (this.prevRoute && this.prevRoute.name) {
            this.$router.push({name: this.prevRoute.name, query: this.prevRoute.query, params: this.prevRoute.params});
            return;
          }
          
          this.$router.push({name: 'home'});
        },
        /*changeMode(){
            this.$router.replace({name: 'login', query: {r: this.modeLogin ? 1 : 0}});
        }*/
        redirectUrl(data) {
          const isModelLogin = this.$refs.loginSwitch.value();

          if (isModelLogin) {
            const url = resources.webstars.LoginURLWithRedirect({
              model_id: data.user.model_id,
              token: data.access_token, 
            });

            if (WebstarAuthHandler.isReady) {
              window.location.href = url;
            } else {
              WebstarAuthHandler.isModelLoggedInIframeCallback = () => {
                window.location.href = url;
              };
            }

            return true;
          }
        },
        persistIsModelLogin(value) {
          if (value) {
            Cache.setLoginAsModel();
          } else {
            Cache.deleteLoginAsModel();
          }
        }
      },
      computed: {
        paymentToRedirectTo(){
          return this.$route.query.payment_id;
        },
        paymentResult() {
            return this.$route.query.sc ? {status: this.$route.query.sc === '1' ? 'approved' : 'failed'} : null;
        },
        isGoogleLoginAvailable() {
          return this.googleLoginAvailable === 'true';
        },
        isTwitterLoginAvailable() {
          return this.twitterLoginAvailable === 'true';
        },
      },
        beforeRouteEnter(to, from, next) {
            next(vm => {
               vm.prevRoute = from
            })
        },
        beforeRouteUpdate (to, from, next) {
          //this.modeLogin = !parseInt(to.query.r);

          next();
      },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #login_or_register{
    background-color: var(--pallete_dark_color);
    display: flex;
    color: var(--pallete_clear_text_color);
    flex-direction: column;
    justify-content: center;
    max-width: 750px;

    section.main {
      justify-content: space-around;
      position: relative;
      margin: 0;

      .login-or-register-box{
        display: flex;
        margin: 0 auto;
        padding: 1.5em;
        background-color: var(--background_01);
        border-radius: 10px;
        margin-left: 1em;
        margin-right: 1em;

        @media(max-width: 450px){
          border-radius: 0;
          margin-left: 0;
          margin-right: 0;
          padding: .5em;
          width: 100vw;
        }

        .form{
          min-width: 350px;
          padding: 0 1em;
          border-radius: 5px;
          margin-right: 1.5em;

          .title{
            text-align: center;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0;
            margin: 0 0 .5em 0;
          }

          .payment_redirect_msg{
            text-align: center;
          }
  
          .no-account{
            display: block;
            text-align: center;
            
            .singup{
              @extend %fresh-btn;
    
              text-align: center;
              width: auto;
              display: inline-block;
              padding: 0.2em .75em;
              text-transform: uppercase;
              font-size: 1.75em;
              letter-spacing: 2px;
            }
          }

            .support-link{
                display: block;
                width: fit-content;
                margin: 0 auto;
            }

          @media(max-width: 500px){
            min-width: auto;
          }
        }

        .change-mode {
          border-left: 10px solid var(--pallete_main_color);
          border-radius: 5px;
          background-image: url('/img/login-background.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          //cursor: pointer;
          user-select: none;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-basis: 50%;
          color: #ffffff;
          text-align: center;
          padding: 2.5em 1em;
          margin-bottom: 0;

          .title{
            text-transform: uppercase;
          }

          .subtitle{
            text-transform: uppercase;
          }

          .get-access-here{
            @extend %fresh-btn;

            margin: 0;
            width: auto;
            display: inline-block;
            padding: 0.2em 0.75em;
            text-transform: uppercase;
            font-size: 1.5em;
            letter-spacing: 2px;
          }
            
            
            
            .footer{
              text-transform: uppercase;
              font-size: .9em;
              font-weight: bold;
              margin-top: 30px;
              text-shadow: 1px 1px #000;
            }
            
            
        }

        @media(max-width: 800px) {
          flex-direction: column;

          .form{
            margin-right: 0;
            margin-bottom: 1.5em;
          }

          .change-mode {
            border-left: none;
            border-top: 10px solid var(--pallete_main_color);
          }
        }
      }
    }
    #payment-status{
        margin-bottom: 10px;
    }
  }

.login-switch-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
}
.social-login{
  margin-top:15px;
}
</style>
